import { FileX } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';

export const MissingFileIcon = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span
        className="inline-flex items-center justify-center p-1 text-neutral-400"
        aria-label="Dokument niedostępny"
      >
        <FileX className="size-4" />
      </span>
    </TooltipTrigger>
    <TooltipContent className="max-w-xs">
      Dokument niedostępny — ta zgoda została dodana po rejestracji klienta i
      nie została jeszcze przez niego zaakceptowana.
    </TooltipContent>
  </Tooltip>
);
